import { Boundaries } from "@planzone/core";
import { State } from "./types";

function handleProjectsTransfer(
  state: State,
  { projects, destination }: Boundaries["transferProjects"]["success"],
): State {
  return state.map((result) =>
    result.zone.uuid === destination.uuid
      ? {
          ...result,
          projects: [...result.projects, ...projects],
        }
      : {
          ...result,
          projects: result.projects.filter(
            (project) => !projects.find(({ uuid }) => uuid === project.uuid),
          ),
        },
  );
}

export { handleProjectsTransfer };
